import { render, staticRenderFns } from "./ScoreRecords.vue?vue&type=template&id=97c41046&scoped=true"
import script from "./ScoreRecords.vue?vue&type=script&lang=js"
export * from "./ScoreRecords.vue?vue&type=script&lang=js"
import style0 from "./ScoreRecords.vue?vue&type=style&index=0&id=97c41046&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c41046",
  null
  
)

export default component.exports